export const campaign = {
  field: {
    id: 'ID',
    name: 'Название',
    status: 'Статус',
    skills: 'Учитывать навыки операторов',
    type: 'Тип',
    time: 'мин',
    direction: 'Направление',
    url: 'URL',
    attempt: 'Попытка',
    max_attempts: 'Количество попыток',
    attempts_interval_min: 'Время между попытками (мин.)',
    calls_limit: 'Кол-во одновременных звонков',
    caller_id: 'Caller ID',
    weight: 'Вес кампании',
    avg_task: 'Средняя продолжительность задачи (сек.)',
    max_time: 'Максимальное время ожидания (сек.)',
    dt_calls: 'DT Affecting calls',
    instance: 'Сервер',
    asr: 'Фиксированный ASR',
    asr_default: 'ASR по умолчанию',
    lost_calls: 'Период рассчета потерянных звонков (мин.)',
    percent_lost_calls: 'Процент потерянных звонков',
    pbx_number: 'Номер виртуальной АТС',
    record: 'Запись разговора',
    sort: 'Сортировка задач',
    wait_operator: 'Время ожидания ответа оператора (сек.)',
    resetAsr: 'Автосброс ASR',
    operators: 'Управление операторами',
    operator: 'Операторы',
    empty_data: 'Нет соответствующих данных',
    select_or_type: 'Выбрать или ввести',
    machine_detection: {
      duration: 'Время определения (сек.)',
      mode: 'Режим',
      on_threshold: 'Завершение звонка',
      threshold: 'Пороговое значение (%)'
    },
    welcome_message: 'Приветственное сообщение'
  },

  answering_machine: 'Автоответчик',

  select: {
    mode: {
      notification: 'Оповещение',
      aggressive: 'Агрессивный'
    },
    type: {
      synchronous: 'Синхронный',
      asynchronous: 'Асинхронный'
    }
  },

  table: {
    action: {
      show_detail_stat: 'Посмотреть статистику',
      create: 'Добавить кампанию'
    }
  },

  sort: {
    type: {
      priority: 'Приоритет',
      lead_date: 'Дата создания заказа',
      attempts: 'Попытки'
    },
    order: {
      asc: 'По возрастанию',
      desc: 'По убыванию'
    }
  },
  welcome_message: {
    success: 'Медиафайл успешно загружен',
    modal_title: 'Выбрать или загрузить медиафайл'
  },

  tooltips: {
    welcome_message: 'Вы можете загрузить медиа файл, который клиент услышит до подключения оператора к разговору.',
    welcome_message_with_instance: "Вы можете использовать медиафайл только для определенного сервера.",
    welcome_message_with_select_instance: 'Вы можете использовать медиафайл только для определенного сервера. Выберите сервер.',
    weight:
      'Используется для приоритезирования кампании. Если один оператор работает с несколькими кампаниями, то задачи кампании с большим весом обрабатываются первыми.',
    avg_task: 'Включает в себя время разговора с клиентом и время для работы с карточкой клиента',
    dt_calls:
      'Количество звонков на основе которых происходит вычисление длительности набора номера в секундах от момента инициации до ответа клиента',
      empty_data: 'База данных пустая',
      need_support: 'Экспорт номеров из БД сейчас не доступен. Обратитесь в поддержу',
    fix_asr:
      'Строго заданное значение ASR которое не будет меняться в течении всей кампании. Остальные настройки ASR игнорируются',
    wait_operator:
      'Пороговое значение длительности ожидания клиентом ответа оператора. Вводится чтобы отделить клиентов, которые пытались подождать ответа, от клиентов, кто сразу сбрасывает вызов',
    sort:
      'Позволяет сортировать задачи кампании по приоритету, дате создания заказа, количеству попыток. Есть возможность указывать направление сортировки. При помощи курсора можно менять порядок, добавляя, перетаскивая и удаляя критерии.',
    max_time: 'Максимальное время ожидания ответа клиента на звонок',
    sync_type:
      'При синхронном типе клиент сначала будет подключён к определителю автоответчика и только после анализа звонка произойдет подключение к оператору.',
    async_type:
      'При асинхронном типе клиент моментально будет подключен к оператору, определитель автоответчика работает в фоновом режиме.',
    duration:
      'Задайте допустимое время определения автоответчика. Наиболее точный результат достигается через 7 секунд после начала обработки звонка определителем автоответчика.',
    mode:
      'При режиме оповещения определитель автоответчика будет фиксировать результат обработки звонка в статистике, но не будет самостоятельно сбрасывать звонок.',
    threshold: 'При достижении заданного значения будет происходить завершение звонка.',
    drop_call: 'Настройка позволяет самостоятельно завершать звонки при обнаружении автоответчика.',
    hangup_cause_code: {
      1: 'Неназначенный номер',
      2: 'Неизвестная транзитная сеть',
      3: 'Отсутствие коннективити (маршрутизации) между сетями инициатора вызова и вызываемого абонента',
      5: 'К вызываемому номеру был подставлен ошибочный телефонный префикс.',
      6: 'Проблемы на канале связи. ',
      7: 'Пользователь получил входящий вызов и что пользователь уже имеет аналогичный вызов',
      8: 'Упреждение',
      16: 'Вызов был закончен естественным образом',
      17: 'Пользователь занят',
      18: 'Пользователь не ответил',
      19: 'Аппарат вызываемого абонента звонил, но он не ответил на звонок',
      21: 'Вызов отключен',
      22: 'Вызываемый номер более не существует. ',
      26: 'Пользователю не был назначен входящий вызов',
      27: 'Телефонная сигнализация не может быть доставлена через выбранный NIC',
      28: 'Неправильный формат вызываемого номера или номер указан не полностью',
      29: 'Устройство отклонено на уровне сети',
      30: 'Ответ на запрос о состоянии',
      31: 'Неопределенная ошибка',
      34: 'Нет доступного для установления соединения канала связи',
      38: 'Сетевое соединение функционирует не корректно',
      41: 'Временная неработоспособность сервиса. ',
      42: 'В настоящее время, оборудование коммутации испытывает пиковые значения нагрузки и не может обработать запрос',
      43: 'Сеть (L3) не может доставить информацию о доступе к удаленному пользователю',
      44: 'Запрошенный канал связи недоступен',
      50: 'Пользователь запросил услугу, которую он не может получить по причине отсутствия доступа к ней',
      52: 'Исходящий вызов запрещен для абонента',
      54: 'Входящий вызов запрещен для абонента',
      57: 'Пользователь запросил расширение пропускной способности канала до оборудования, но не имеет права на подобные итерации',
      58: 'Пользователь запросил расширение пропускной способности канала до оборудования, но в данный момент данная функция не доступна',
      65: 'Служба передачи (переноса) информации не реализована',
      66: 'Устройство, посылающее данную причину не поддерживает указанный типа канала связи',
      69: 'Устройство, отсылающее эту причину не поддерживает запрашиваемые дополнительные услуги',
      81: 'Устройство, отсылающее эту причину, получило сообщение с идентификатором вызова, который в настоящее время не используется на интерфейсе сети пользователя',
      88: 'Система получила запрос на установление соединения с параметрами, которые не могут быть обслужены',
      95: 'Неправильное сообщение.',
      96: 'В полученном оборудованием сообщение отсутствует важное для его обработки поле',
      97: 'Получено устройством сообщение не может быть интерпретировано на оборудовании',
      98: 'Сообщение не совместимо с текущим состоянием звонка или не может быть интерпретировано оборудованием',
      99: 'Информационный элемент не существует или не может быть интерпретирован оборудованием',
      100: 'Элемент не может быть интерпретирован.',
      101: 'Полученное сообщение не соответствует состоянию вызова',
      102: 'Процедура восстановления по причине тайм - аута параллельно с алгоритмами обработки ошибок',
      111: 'Ошибка протокола',
      127: 'На этапе установления соединения произошел сбой'
    },
    caller_id: 'Необходимо купить номер или добавить свой. Для этого перейдите в раздел'
  },

  filter: {
    status: {
      title: '@:autocaller_v2.campaign.field.status',
      active: 'Активный',
      not_active: 'Неактивный'
    },
    type: {
      title: '@:autocaller_v2.campaign.field.type',
      predictive: 'Предиктивный',
      progressive: 'Прогрессивный'
    },

    name: {
      title: '@:autocaller_v2.campaign.field.name'
    },

    pbx_number: {
      title: '@:autocaller_v2.campaign.field.pbx_number'
    },

    caller_id: {
      title: '@:autocaller_v2.campaign.field.caller_id'
    },

    weight: {
      title: '@:autocaller_v2.campaign.field.weight'
    },

    avg_task: {
      title: '@:autocaller_v2.campaign.field.avg_task'
    },

    max_time: {
      title: '@:autocaller_v2.campaign.field.max_time'
    },

    dt_calls: {
      title: '@:autocaller_v2.campaign.field.dt_calls'
    }
  },

  modal: {
    remove: {
      content: `Вы действительно хотите удалить кампанию <b>{name}<b>?`
    },

    change_status: {
      enable: 'Вы уверены, что хотите запустить автообзвон?',
      disable: 'Вы уверены, что хотите остановить автообзвон?'
    },

    notice_pbx_module_required: {
      content:
        'Для создания кампаний предиктивного обзвона подключите услугу "<strong>Виртуальная АТС</strong>".',
      ok: 'Подключить'
    }
  },

  create: {
    title: '@:autocaller_v2.breadcrumb.campaign.new'
  },

  edit: {
    title: '@:autocaller_v2.breadcrumb.campaign.edit'
  },

  form: {
    title: 'Основная информация',
    parameters: 'Параметры кампании',
    settings: 'Дополнительные настройки',
    determinant: 'Определитель автоответчика',
    recipients_title: 'Получатели',
    save_btn: 'Сохранить',
    update_btn: 'Обновить'
  }
};
